/**
 * White-glove waiting: after checkout, before credentials submitted.
 * Plan: billing_infrastructure_plan §1.8. "Check your email for next steps."
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function WhiteGloveWaiting() {
  return (
    <Card className="max-w-md mx-auto">
      <CardHeader>
        <CardTitle>Setup in progress</CardTitle>
      </CardHeader>
      <CardContent>
        <p>Check your email for next steps.</p>
      </CardContent>
    </Card>
  );
}
